import useSWR from 'swr';
import { IForm, PaginatedData, customSWRConfig, customSWRPaginatedResponse } from '../../model/types';
import { localizedSearchTermForApi } from '../../utils/helpers';
import useSWRCacheKeys from '../useSWRCacheKeys';

export default function useForms<T extends IForm>(
    params?: { size?: number; page?: number; isActive?: boolean; sort?: string; searchTerm?: string },
    config: customSWRConfig = {}
): customSWRPaginatedResponse<T> {
    const keys = useSWRCacheKeys(
        `/forms${
            params
                ? `?${params?.isActive ? 'active' : 'inactive'}${params?.size ? `&size=${params?.size}` : ''}${
                      params?.page ? `&page=${params?.page}` : ''
                  }${params?.sort ? `&sort=${params?.sort}` : ''}${
                      params?.searchTerm ? `&searchTerm=${localizedSearchTermForApi(params?.searchTerm)}` : ''
                  }`
                : ''
        }`
    );
    return useSWR<PaginatedData<T>>(params?.isActive !== undefined ? keys : null, { ...config });
}
const usePaginatedFormsNoQueryParams = (config: customSWRConfig = {}): customSWRPaginatedResponse<IForm> => {
    const requestFlag = config?.requestFlag ?? true;

    const keys = useSWRCacheKeys(requestFlag ? '/forms' : null);

    return useSWR<PaginatedData<IForm>>(keys, { ...config });
};

export { usePaginatedFormsNoQueryParams };
